import zoid from 'zoid';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
var BASE_URL = 'https://preview.widgets.ninetailed.io/v2';
var bridge;
var PreviewBridge = function PreviewBridge(_ref) {
  var _ref$url = _ref.url,
    _url = _ref$url === void 0 ? BASE_URL : _ref$url;
  if (!bridge) {
    bridge = zoid.create({
      tag: 'ninetailed-preview',
      url: _url,
      dimensions: {
        width: "432px",
        height: "100vh"
      }
    });
  }
  return bridge();
};
export { PreviewBridge };